<template>
  <div class="ImageTitle flex flex-column">
    <span class="zh fw-n">{{ Zh }}</span>
    <span class="en fw-n">{{ En }}</span>
  </div>
</template>

<script>
export default {
  name: "ImageTitle",
  props: {
    En: String,
    Zh: String,
  },
};
</script>

<style lang="less" scoped>
.zh,
.en {
  color: #fff;
}

.zh {
  font-size: 30px;
}

.en {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageTitle.vue